import * as React from "react";
import { IconProps } from "./types";

export const FileHeart03Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2ZM11.9973 11.8306C11.1975 10.9216 9.8639 10.6771 8.86188 11.5094C7.85986 12.3418 7.71879 13.7335 8.50568 14.7179C9.29257 15.7024 11.9973 18 11.9973 18C11.9973 18 14.7019 15.7024 15.4888 14.7179C16.2757 13.7335 16.1519 12.3331 15.1326 11.5094C14.1134 10.6858 12.797 10.9216 11.9973 11.8306Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(FileHeart03Icon as React.FunctionComponent).displayName = "FileHeart03Icon";

export default FileHeart03Icon;
